import React from "react";
import JSONPretty from "react-json-pretty";
import "react-json-pretty/themes/monikai.css";
export default function Code({ code }) {
  return <JSONPretty id="json-pretty" data={code}></JSONPretty>;
}
